interface IENV {
	appCode?: string;
	productCode?: string;
	envType?: string;
	apiEndpoint?: string;
	appName?: string;
	/** Per-product "Goto Console" targets, keyed by product type (pos/hrm/asm/file). */
	consoles?: Record<string, string>;
	/** Product name shown in the UI and appended to the browser tab title. */
	brandName?: string;
	/** Public path to this deployment's logo, e.g. "/logo.png". */
	brandLogo?: string;
	/** Public path to this deployment's favicon. */
	brandFavicon?: string;
	/** This console's name beside the logo in the sidebar's brand strip. */
	sidebarTitle?: string;
	/** The brand's two colours (the logo's): main and dark. They paint the sign-in screens. */
	brandColor?: string;
	brandColorDark?: string;
	/** Support address shown in the footer. */
	supportEmail?: string;
	/** Support phone shown in the footer. */
	supportPhone?: string;
	/** Marketing site origin for the public About/Contact links. Empty => links hidden. */
	marketingUrl?: string;
	/**
	 * Short module codes this deployment is allowed to show (e.g. ["HRM"]).
	 * Empty means "no filtering" — which is what every ErpBoi build does.
	 */
	moduleAllowlist?: string[];
	/**
	 * Pricing, module activation and billing (invoices, payments). Off on an install whose
	 * subscriptions are not sold through the portal: every such screen, link and route is gone.
	 */
	billingEnabled: boolean;
	/**
	 * Self-registration (/signup) and every "30-day trial" link. Off on an install whose companies
	 * are set up by the operator, not by visitors: the route and all its entry points are gone.
	 */
	signupEnabled: boolean;
}

export const ENV: IENV = {
	appCode: process.env.REACT_APP_CODE || '',
	productCode: process.env.REACT_APP_PRODUCT_CODE || '',
	appName: process.env.REACT_APP_NAME || "",
	envType: process.env.REACT_APP_ENV_TYPE || "",
	apiEndpoint: process.env.REACT_APP_GETWAY || "",
	consoles: {
		pos: process.env.REACT_APP_CONSOLE_POS || "",
		hrm: process.env.REACT_APP_CONSOLE_HRM || "",
		ams: process.env.REACT_APP_CONSOLE_AMS || "",
		docs: process.env.REACT_APP_CONSOLE_DOCS || "",
		// Keyed by LOWERCASE public.modules.code — that is how Dashboard/Home look a console up.
		desk: process.env.REACT_APP_CONSOLE_DESK || "",
		store: process.env.REACT_APP_CONSOLE_STORE || "",
		labor: process.env.REACT_APP_CONSOLE_LABOR || "",
	},
	brandName: process.env.REACT_APP_BRAND_NAME || "ErpBoi",
	brandLogo: process.env.REACT_APP_BRAND_LOGO || "/logo.png",
	brandFavicon: process.env.REACT_APP_BRAND_FAVICON || "/favicon.ico",
	sidebarTitle: process.env.REACT_APP_SIDEBAR_TITLE || "Portal",
	// ErpBoi's logo blue and navy.
	brandColor: process.env.REACT_APP_BRAND_COLOR || "#015fee",
	brandColorDark: process.env.REACT_APP_BRAND_COLOR_DARK || "#011746",
	supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@erpboi.com",
	supportPhone: process.env.REACT_APP_SUPPORT_PHONE || "+8801 321 841 440",
	marketingUrl: process.env.REACT_APP_MARKETING_URL || "",
	moduleAllowlist: (process.env.REACT_APP_MODULE_ALLOWLIST || "")
		.split(",")
		.map((s) => s.trim().toUpperCase())
		.filter(Boolean),
	// Only an explicit "false" turns it off, so a build without the var behaves as before.
	billingEnabled: process.env.REACT_APP_BILLING_ENABLED !== "false",
	// Same rule: only an explicit "false" turns it off.
	signupEnabled: process.env.REACT_APP_SIGNUP_ENABLED !== "false",
};
